<template>
    <div class="contact-us1-container">
        <div class="content-positining text" style="padding-left: 0; top: 0;">
            <div class="user__headers">
              Contact Us
            </div>
            <div class="input-area">
              <div class="input-field-area">
                  <div>What is your name?</div>
                  <input type="text" placeholder="eg. Jane Dow" class="input-filed" v-model="name">
              </div>
              <div class="input-field-area">
                  <div>What is your email?</div>
                  <input type="text" placeholder="eg. myemail@myemail.com" class="input-filed" v-model="email">
              </div>
              <div class="input-field-area">
                  <div style="margin-bottom: 10px;">Please type in your message below</div>
                  <textarea id="text-area" name="message" cols="30" rows="10" v-model="message" style="width: 350px; height: 300px;"></textarea>
              </div>
              <button class="adway-btn-class" @click="makeRequest" style="width: 100%; height: auto; padding: 10px;">
                  <span>Send</span>
                  <img src="./../../assets/right-arrow.png" alt="left arrow" style="width: 19px;">
              </button>
            </div>
        </div>
    </div>
</template>

<script>
import toast from '@utils/toast.js'
import Config from '@utils/Config.js'
export default {
  name: 'ContactUs',
  data: function () {
    return {
      name: '',
      email: '',
      message: '',
      config: Config
    }
  },
  components: {
  },
  methods: {
    makeRequest () {
      var url = '/send/message'
      var body = {
        API_KEY: '',
        body: {
          name: this.name,
          email: this.email,
          message: this.message
        }
      }
      this.request(url, 'GET', body).then((response) => {
        if (response.code === 0){
          toast.successMessage('Message send')
          this.$emit('contactpage2')
        } else {
          toast.errorMessage(response.message)
          if (response.code === 112) {
            this.checkTokenConditions(this.makeRequest)
          }
        }
      }).catch((error) => {
        toast.errorMessage(error)
      })
    },
    checkTokenConditions (callback) {
      try{
        var expiresDate = new Date(this.token.expires)
      } catch (err) {
        this.$router.push('/login')
      }
      var now = new Date()
      if (expiresDate <= now) {
        this.store.commit('setToken', {})
        this.$router.push('/login')
      } else {
        var body = {
          code: '',
          refresh_token: this.token.refresh_token
        }
        this.request('/refresh/token', 'POST', body).then((response) => {
          if (response.code === 0 ) {
            store.commit('setToken', response.data[0])
            store.commit('setDriver', response.data[0].driver)
            callback()
          } else if (response.code === 112) {
            this.store.commit('setToken', {})
            this.$router.push('/login')
          }
        }).catch((error) => {
        })
      }
      var token = this.token
      token.redirect = false
      this.store.commit('setToken', token)
    }
  }
}
</script>

<style scoped>
  .input-area{
    margin-top: 30px;
  }

  .input-field-area div{
    font-size: 14px;
    margin-bottom: 5px;
  }

  .adway-btn-class{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .adway-btn-class span{
    font-size: 16px;
    font-weight: bold;
  }

  .adway-btn-class img{
    margin-left: 10px;
  }

  input {
    border: 1px solid #CCD4E0;
    border-radius: 5px;
    box-shadow: 0px 0px 6px rgba(81, 95, 152, 0.161);
    height: 35px;
    box-sizing: border-box;
  }

  textarea{
    border: 1px solid #CCD4E0;
    border-radius: 5px;
    box-shadow: 0px 0px 6px rgba(81, 95, 152, 0.161);
    box-sizing: border-box;
  }
  
  @media only screen and (max-width: 600px) {
    .contact-us1-container{
      width: 100%;
      margin-top: 30px;
    }

    .user__headers{
      font-size: 24px;
    }

    input{
      width: 100%;
    }

    textarea{
      width: 100% !important;
    }

    .input-field-area div{
      font-size: 12px;
      margin-bottom: 5px;
    }

    .adway-btn-class{
      width: 100% !important;
      height: auto !important;
      padding: 10px !important;
    }

    .adway-btn-class span{
      font-size: 12px !important;
    }

    .adway-btn-class img{
      margin-left: 5px !important;
      margin-bottom: 0 !important;
      width: 20px;
    }

    .content-positining{
      width: 100% !important;
    }
  }
</style>